export default "__VITE_PUBLIC_ASSET__f12fb7ec__"